import React from "react";
import TableRow from "./TableRow";
import { Table } from "semantic-ui-react";
import { hasResultsAndActivated } from "../helpers/EventUtils";

const TableList = ({ showRows, bridgeEvents, onEventSelect }) => {
  const renderEmptyFragment = ({ event_id }) => (
    <React.Fragment key={event_id} />
  );

  const renderTableRow = (bridgeEvent) => (
    <TableRow key={bridgeEvent.event_id} bridgeEvent={bridgeEvent} />
  );

  const renderedList = bridgeEvents
    .filter((x) => hasResultsAndActivated(x))
    .map((x, index) => {
      return index <= showRows ? renderTableRow(x) : renderEmptyFragment(x);
    });

  return <Table.Body style={{ fontSize: 16 }}>{renderedList}</Table.Body>;
};




export default TableList;
